import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getSSOData } from "../../actions/admin-actions";
import Loading from "../../common-components/Loading";

const Sso = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const ssoData = useSelector((state) => state.adminReducer.ssoData);

  useEffect(() => {
    if (ssoData && ssoData.status && ssoData.status === 200) {
      const data = ssoData.data;
      if (data.Role) {
        const roles = data.Role;
        localStorage.setItem("token", data["Access Token"]);
        localStorage.setItem("Is_Loggedin", true);
        localStorage.setItem("Login_User_Name", data.Name);
        localStorage.setItem("Last_Login_Time", new Date());
        localStorage.setItem("roles", JSON.stringify(roles));
        localStorage.setItem("email", data.Email);
        localStorage.setItem("employeeId", data.empId);
        localStorage.setItem("accessType", data.accessType);
        if (data.Module) localStorage.setItem("module", data.Module);
        if (roles.includes("SU")) localStorage.setItem("isSuperUser", true);
        else localStorage.setItem("isSuperUser", false);
        if (
          roles.includes("PC") ||
          roles.includes("DPM") ||
          roles.includes("PM") ||
          roles.includes("OV") ||
          roles.includes("SU")
        )
          window.location.assign("/projects/financial-dashboard");
      }
    }
    if (ssoData && ssoData.status && ssoData.status === 400) {
      history.push("/logout");
    }
  }, [ssoData]);

  useEffect(() => {
    if (location.pathname.includes("result")) {
      if (
        location.pathname.split("/").length > 3 &&
        location.pathname.split("/")[3]
      )
        dispatch(getSSOData(location.pathname.split("/")[3]));
    }
  }, []);

  return <Loading />;
};

export default Sso;
